import { ITelemetryLogger, ITelemetryEvent, ITelemetryError } from '../../interfaces/ITelemetryLogger';

/**
 * Log module which exposes static methods to log events.
 * This is a lower level API, that is exposed only to provide a means for providing mocks for unit test purposes/etc.
 * Prefer using an implementation of ILogEvent to batch the event rather than using this API to log events directly.
 * Functions in this class call corresponding method of ITelemetryLogger, which should first be assigned with a call to setLoggerInstance.
 *
 * @see ITelemetryLogger
 * @see LoggerType
 */
let loggerInstance: ITelemetryLogger | null = null;

export function setLoggerInstance(instance: ITelemetryLogger) {
  loggerInstance = instance;
}

/**
 * This is a direct pipe for the Augloop runtime to directly log AugLoop events
 */
export function getLoggerInstanceForAugLoop(): ITelemetryLogger {
  return loggerInstance;
}

/**
 * Do not call this directly. Prefer using an ILogEvent. Errors is an exception
 * @param logEvent LogEvents logging table to associated with
 * @param data the payload to log
 */
export function LogEvent<T extends string>(event: ITelemetryEvent<T>) {
  if (loggerInstance == null)
    return;

  loggerInstance.LogEvent(event);
}

export function LogError(error: ITelemetryError) {
  if (loggerInstance == null)
    return;

  loggerInstance.LogError(error);
}
